import config from '@/config'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/initiatives')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/initiatives']),
  beforeLoad: async ({ context }) => {
    // Flag off: the feature is hidden everywhere, so a direct URL falls back to the module home.
    if (!config.featureFlags.initiatives) throw redirect({ to: '/credit/welcome' })
    context.handleRoutePermissions(Route)
  },
})
